export default __webpack_public_path__ + "static/media/Cory.fd0bbb84.png";